import React from "react";
import "./SkipNavLink.scss";

const SkipNavLink: React.FC = () => (
  <a href="#main-content" className="skip-nav-link">Skip to main content</a>
);

export default SkipNavLink;